export const reportTypes = { GRID: 1, CUSTOM: 2 };
export const fieldTypes = { Number: 1, String: 2, Boolean: 3, DateTime: 4 };
